import { Badge, EmptyState, Eyebrow, StrongText, Subheading, SurfaceCard, SurfaceRow } from '../../../../components/ui'
import { BeakerIcon } from '@heroicons/react/20/solid'
import { uiClasses } from '../../../shared/uiClasses'
import { TestsPartnerStrip } from './TestsPartnerStrip'
import { TestsSummaryStats } from './TestsSummaryStats'
import { PARTNER_COLORS } from './partnerColors'
import type { TestCatalogItem, TestPartner } from './types'

interface TestsOverviewCardProps {
  orderedCount: number
  partnerCount: number
  catalogCount: number
  categoryCount: number
  partners: TestPartner[]
  popularTests: TestCatalogItem[]
}

export function TestsOverviewCard({
  orderedCount,
  partnerCount,
  catalogCount,
  categoryCount,
  partners,
  popularTests,
}: TestsOverviewCardProps) {
  return (
    <SurfaceCard as="article" className="tests-overview-shell">
      <div className="tests-overview-layout">
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <Subheading variant="dashboard">Diagnostic tests</Subheading>
            <Badge variant="zinc">{orderedCount} ordered</Badge>
          </div>

          <TestsSummaryStats
            partnerCount={partnerCount}
            catalogCount={catalogCount}
            categoryCount={categoryCount}
          />

          <TestsPartnerStrip partners={partners} />
        </div>

        <SurfaceRow as="aside" className="tests-popular-shell">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <Eyebrow variant="section" tone="subtle">Popular picks</Eyebrow>
            <Badge variant="zinc">{popularTests.length}</Badge>
          </div>
          <div className="tests-popular-grid mt-3">
            {popularTests.length === 0 ? (
              <EmptyState
                className="!py-5"
                icon={BeakerIcon}
                title="No highlighted tests yet"
                description="Popular picks will appear here."
                titleClassName={uiClasses.textSecondary}
                descriptionClassName={uiClasses.textSubtle}
                iconClassName={uiClasses.textFaint}
              />
            ) : (
              popularTests.map((test) => (
                <SurfaceRow key={test.id} className="tests-popular-item">
                  <StrongText>{test.name}</StrongText>
                  <div className="mt-2 flex flex-wrap items-center justify-between gap-2">
                    <Badge variant={PARTNER_COLORS[test.partner] ?? 'zinc'}>
                      {test.partner}
                    </Badge>
                    <StrongText as="span" className="tabular-nums">${test.price}</StrongText>
                  </div>
                </SurfaceRow>
              ))
            )}
          </div>
        </SurfaceRow>
      </div>
    </SurfaceCard>
  )
}
